import { Button, ChevronLeftIcon, Typography } from "@fanka/ui-admin";
import { NotFoundIcon } from "@on-site/features/notFound/ui/NotFoundIcon";
import { withHelmet } from "@on-site/hoc/withHelmet";
import { PageLayout } from "@on-site/layouts/PageLayout";

export const NotFoundPage = withHelmet(() => {
  return (
    <PageLayout>
      <div className="mx-auto h-full w-full max-w-[424px] pt-10">
        <h2 className="text-brand-beige text-center text-[50px] font-bold leading-[1.2]">404</h2>
        <p className="text-brand-beige mt-1 text-center text-[24px]">Page not found</p>

        <div className="mt-[30px] flex justify-center">
          <NotFoundIcon />
        </div>

        <h3 className="text-ui-500 mt-10 text-center">
          <Typography.UiText as="span" size="lg" bold>
            ご指定のページは見つかりませんでした。
          </Typography.UiText>
        </h3>

        <p className="mb-12 mt-3">
          <Typography.UiText as="span" size="md">
            お探しのページは、削除・変更された、もしくは現在ご利用できないページの可能性があります。
          </Typography.UiText>
        </p>

        <Button
          styleType="outline"
          icon={<ChevronLeftIcon />}
          iconType="left"
          size="lg"
          block
          onClick={() => window.history.back()}
        >
          戻る
        </Button>
      </div>
    </PageLayout>
  );
}, true);
